import { Component } from '@angular/core';
import {UserModel} from "../../models/user.model";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {AuthService} from "../../services/auth.service";
import {UserService} from "../../services/user.service";
import {Subscription} from "rxjs";
import {TitleService} from "../../services/title.service";
import {TranslateService} from "@ngx-translate/core";
import {TrackingHelperService} from "../../services/tracking-helper.service";
import {GoogleAnalyticsService} from "ngx-google-analytics";


@Component({
  selector: 'app-cashier',
  templateUrl: './cashier.component.html',
  styleUrls: ['./cashier.component.scss']
})
export class CashierComponent {

  user!: UserModel | null;
  cashierUrl!: SafeResourceUrl | null;
  lang:string = 'en';

  userSubs?: Subscription;
  urlSubs?: Subscription;
  titleTranslateSubs?: Subscription;

  constructor(
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private titleService: TitleService,
    private translate: TranslateService,
    private trackingService: TrackingHelperService,
    private gaService: GoogleAnalyticsService
  ) {
    //setting page title
    this.titleTranslateSubs?.unsubscribe();
    this.titleTranslateSubs = this.translate.stream('ACCOUNT.CASHIER').subscribe(data => {
      this.titleService.setTitle(`Cashier / ${data}`);
    })

    try {
      this.lang = localStorage.getItem("lang") ?? 'en'
    } catch (error){
      console.warn('Error with localStorage:', error);
    }

    this.urlSubs?.unsubscribe();
    this.urlSubs = this.authService.cashierUrl.subscribe((url: string | null) => {
      if (url) {
        //disable chat in iframes
        url += '&chatButton=0';

        //add btag and tracker to url
          let bTag = this.trackingService.getBannerTag();
          if (bTag) {
            url += `&btag=${bTag}`
          }
          let t = this.trackingService.getTracker();
          if (t) {
            url += `&t=${t}&tracker=${t}`
          }

        this.cashierUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.updateUrlLangParam(url, this.lang));

        //send ga event
        if (this.cashierUrl){
          this.gaService.event('cashier', undefined, undefined, undefined, undefined,{ cashier_visible: true, ...this.trackingService.getAffiliateOptions() });
        }
      }
    })

    this.userSubs?.unsubscribe();
    this.userSubs = this.userService.userObject.subscribe((u: UserModel | null) => {
      this.user = u;
      // console.log(this.user)
    })



  }

  updateUrlLangParam(url: string, lang:string){
    if(url.includes('lang')){
      return url.replace(/lang=[^&]*/, `lang=${lang}`);
    } else {
      return url + `&lang=${lang}`
    }
  }


  ngOnDestroy(): void {
    this.userSubs?.unsubscribe();
    this.urlSubs?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();

    if (this.cashierUrl){
      this.gaService.event('cashier', undefined, undefined, undefined, undefined,{ cashier_visible: false, ...this.trackingService.getAffiliateOptions() });
    }

  }


}
